// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__HUkP3","content":"Preloader_content__l9EV+"};